export default function ByComponentConfig() {
  return {
    itemName: 'Component',
    itemNamePlural: 'Components',
    commonStateItemSelector: commonState => commonState.componentList,
    getUrlParamName: 'component_ids'
  };
};